export default {
  'contactIndustry': {
    'Student': '學生',
    'Education': '教育',
    'Transportation': '大眾傳播',
    'Communications': '出版／藝文 ',
    'Technology': '電子科技／資訊／軟體',
    'Construction': '一般傳統製造',
    'Consultant': '金融／法律／會計／顧問 ',
    'Service': '一般服務業',
    'Not For Profit': '政治宗教社會福利',
    'Other': '其他',
  },

  'contactInterest': {
    'Photography': '攝影/錄影/剪輯',
    'Art Design': '美工設計',
    'Information Engineering': '資訊工程',
    'Machinery': '木工機械',
    'Other': '其他',
  },

  'contactInterestedActivity': {
    'Lectures':	'講座',
    'Exhibition':	'展覽',
    'Recruitment': '招募任務',
  },

  'contactHowDidIKnowTFT': {
    'Website': 'Teach For Taiwan官網',
    'FB': 'Facebook 粉絲專頁',
    'Media': '媒體報導',
    'Referral': '親友推薦',
    'Campus Recruitment': '校園招募活動',
    'Exhibition': '相關展覽講座',
    'Founder': '創辦人之相關書籍報導',
    'Project Donation': '專案募款',
    'Other': '其他',
  },

  'oppoOrderType': {
    'CREDIT': '信用卡單次繳款',
    'ATM': 'ATM轉帳繳款',
    'CVS': '超商代碼繳款',
  },

  'conatctInvoiceType': {
    'Single_e': '寄送單筆電子收據 ',
    'Year_e': '年度電子',
    'Single_paper': '單筆紙本',
    'No_Need': '不需要收據',
    'Year_paper': '寄送年度紙本收據',
  },

  'Receipt_Send_Status__c': {
    'Preparing': '準備中',
    'Sent': '已寄送',
  },

  'contactPreferredNotification': {
    'paper': '紙本好溫暖！我願意收到實體文宣',
    'electric': '環保愛地球！請寄電子文宣給我即可',
    'no_need': '不需要收到任何資訊，我會主動關注',
  },
};
